// extracted by css-extract-rspack-plugin
export default {"icon":"icon-E8iQkh","defaultSize":"defaultSize-ZYLGf4"};